import { render, staticRenderFns } from "./ContestCommitteesView.vue?vue&type=template&id=2ed16b89&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ContestCommitteesView.vue?vue&type=script&lang=js&"
export * from "./ContestCommitteesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
installComponents(component, {VIcon,VListTileAction})
